import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedLoop } from "../GeneratedClasses/GeneratedLoop" // GENERATED

export class Loop extends GeneratedLoop {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    const data = {
      id: this.id,
      loopStartValue: this.getTotalIterations(),
      // place: uiData ? uiData : -1,
      jsonTxt: uiData,
    }
    gameInstance.SendMessage("GridManager", "CreateLoopPlethora", JSON.stringify(data))

    // YOUR CREATE CODE HERE
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)

    gameInstance.SendMessage("GridManager", "DestroyLoop", this.id)
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onTotalIterationsUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onCurrentIterationUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    const data = {
      currentValue: newValue,
      id: this.id,
    }
    gameInstance.SendMessage("GridManager", "SetLoopValue", JSON.stringify(data))
  }
}
